import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import useCategories from '../Admin/useCategories';
import './Categorysection.scss';

/**
 * The horizontally scrolling category rail that sits under the header.
 *
 * The previous version rendered a duplicate dropdown of the exact same
 * links, kept a click-outside listener alive for it, and mapped over
 * categories without a `key`. The rail alone covers the same ground.
 */
const Categorysection = () => {
  const { categories, loading } = useCategories();
  const location = useLocation();
  const activeCategory = new URLSearchParams(location.search).get('category');

  return (
    <nav className="category-bar" aria-label="Product categories">
      <div className="category-bar__scroller">
        <NavLink
          to="/allproducts"
          className={({ isActive }) =>
            `category-bar__link${isActive && !activeCategory ? ' is-active' : ''}`
          }
        >
          All Products
        </NavLink>

        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <span key={index} className="skeleton category-bar__skeleton" aria-hidden="true" />
            ))
          : categories.map((category) => (
              <NavLink
                key={category.category_code}
                to={`/category?category=${category.category_code}`}
                className={`category-bar__link${
                  activeCategory === category.category_code ? ' is-active' : ''
                }`}
              >
                {category.category_name}
              </NavLink>
            ))}
      </div>
    </nav>
  );
};

export default Categorysection;
